import Processing from 'ext-ui/components/Processing/Processing'
import React, { ReactElement, useMemo } from 'react'
import { useSelector } from 'react-redux'
import DynamicSaasOnboardingPricingTiers from 'src/app/Onboarding/DynamicSaasOnboardingPricingTiers'
import PricingFeaturesComparisonTable from 'src/app/Onboarding/PricingFeaturesComparisonTable'
import BrandAgnosticFooter from 'src/components/BrandAgnosticFooter/BrandAgnosticFooter'
import BrandPrimaryLogo from 'src/components/BrandPrimaryLogo/BrandPrimaryLogo'
import { Environments } from 'src/configurations'
import { SupportedBrands } from 'src/enums'
import { Rdrct } from 'src/navigation/Lnk'
import { signinUrl } from 'src/navigation/urls'
import { useQueryPricingPlans } from 'src/queries/organizations/pricingPlans/pricingPlans.queries'
import { selectEnvironmentFromState } from 'src/redux/selectors/session.selectors'

import style from './MarcomPricingPage.style'

// TODO: Replace with 6 digit BIN lookup
const MARCOM_ORG_ID = 'org_7TunRwKQVLI86ZF25swi3P'

export default function MarcomPricingPage(): ReactElement {
  const environment = useSelector(selectEnvironmentFromState)

  if (environment === Environments.Prod) {
    return <Rdrct to={signinUrl()} />
  }

  return <MarcomPricingPageContent />
}

function MarcomPricingPageContent(): ReactElement {
  const { data: pricingPlans, isLoading } = useQueryPricingPlans(MARCOM_ORG_ID)

  const sortedPlans = useMemo(() => {
    if (!pricingPlans?.plans) return []
    return [...pricingPlans.plans].sort(
      (a, b) => a.displayOrder - b.displayOrder,
    )
  }, [pricingPlans?.plans])

  const isNonExtendIssuer =
    pricingPlans?.partnerName !== undefined &&
    pricingPlans?.partnerName.toLowerCase() !== SupportedBrands.Extend

  return (
    <div css={style} className="MarcomPricingPage">
      <div className="logo-container">
        <BrandPrimaryLogo />
      </div>
      <div className="SaasOnboardingPricingTiers-container flex-column justify-center align-center gap-20">
        {isLoading ? (
          <Processing />
        ) : (
          <>
            <DynamicSaasOnboardingPricingTiers
              pricingPlans={sortedPlans}
              showVirtualCardAlert={pricingPlans?.showVCUnavailableAlert}
              isNonExtendIssuer={isNonExtendIssuer}
              partnerName={pricingPlans?.partnerName}
            />
            <PricingFeaturesComparisonTable pricingPlans={sortedPlans} />
          </>
        )}
      </div>
      <div className="footer flex-row justify-center">
        <BrandAgnosticFooter logOutOption topMargin={false} />
      </div>
    </div>
  )
}
